console.log('pagina interna about');